import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Input from "../../Input";
import { faMinus, faPlus } from "@fortawesome/pro-regular-svg-icons";
import Button from "../../../button/Button";

interface IProps {
    hideNumbers?: boolean;
    onChange?(value): void;
    minValue?: number;
    maxValue?: number;
    error?: boolean | undefined;
    success?: boolean | undefined;
    filedtitle?: React.ReactNode | undefined;
    help?: React.ReactNode | undefined;
    postchildren?: React.ReactNode | undefined;
    prechildren?: React.ReactNode | undefined;
    forcevalue?: string;
    disabled?: boolean;
}

const InputNumbers = ({ hideNumbers, onChange, minValue, maxValue, ...props }: IProps) => {
    const [value, setValue] = useState(props.forcevalue);

    const onChangeValue = (e) => {
        let value = parseFloat(e.target.value);

        if (isNaN(value)) {
            setValue("");
            if (onChange) onChange("");
            return;
        }

        setValue(value + "");
        if (onChange) onChange(value + "");
    };

    const onMinusClicked = (e) => {
        let returnValue = parseFloat(value) - 1;

        if (isNaN(returnValue)) {
            setValue("0");
            if (onChange) onChange("0");
            return;
        }

        if (minValue !== undefined && returnValue <= minValue) {
            returnValue = minValue;
        }

        setValue(returnValue + "");
        if (onChange) onChange(returnValue + "");
    };
    const onPlusClicked = (e) => {
        let returnValue = parseFloat(value) + 1;

        if (isNaN(returnValue)) {
            setValue("0");
            if (onChange) onChange("0");

            return;
        }

        if (maxValue !== undefined && returnValue >= maxValue) {
            returnValue = maxValue;
        }

        setValue(returnValue + "");
        if (onChange) onChange(returnValue + "");
    };

    useEffect(() => {
        setValue(props.forcevalue);
    }, [props.forcevalue]);

    return (
        <Input
            disabled={props.disabled}
            value={value}
            type="text"
            pattern="[0-9]*"
            placeholder={"Enter number here..."}
            onChange={onChangeValue}
            {...props}
            insideprechildren={
                hideNumbers ? null : (
                    <Button variant="secondary" iconOnly onClick={onMinusClicked}>
                        <FontAwesomeIcon icon={faMinus} />
                    </Button>
                )
            }
            insidepostchildren={
                hideNumbers ? null : (
                    <Button variant="secondary" iconOnly onClick={onPlusClicked}>
                        <FontAwesomeIcon icon={faPlus} />
                    </Button>
                )
            }
        />
    );
};
export default InputNumbers;
